// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__qrZ7y","header":"CardSellers_header__Qa-me","photo":"CardSellers_photo__79MEj","name":"CardSellers_name__9u7dE","details":"CardSellers_details__BtmDa"};